export default __webpack_public_path__ + "static/media/49.bb81af24.jpg";